export default __webpack_public_path__ + "static/Group 642-afb8bbf83746ca8eac44fff4d1f33d90.png";